import Reveal from './Reveal';
import { collectionIndex } from '@/mocks/home';

export default function CollectionIndex() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-100 border-y border-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
            <div>
              <span className="text-xs tracking-[0.3em] text-accent-700 uppercase">Index / 目录</span>
              <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">专题索引</h2>
            </div>
            <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
              下面八个入口按「先认识人、再看出道、最后查证身份」的顺序排列，点任意一栏即可跳到对应段落。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {collectionIndex.map((item, idx) => (
            <Reveal key={item.no} delay={idx * 60}>
              <a
                href={`#${item.anchor}`}
                className="group flex flex-col h-full p-5 rounded-lg bg-background-50 border border-background-200 hover:border-accent-400 transition-colors cursor-pointer"
              >
                <div className="flex items-start justify-between mb-4">
                  <span className="font-heading text-2xl font-bold text-background-400 group-hover:text-accent-500 transition-colors">
                    {item.no}
                  </span>
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-800 group-hover:bg-accent-100 group-hover:text-accent-700 transition-colors">
                    <i className="ri-arrow-right-up-line text-base"></i>
                  </span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}